

<div class="flex flex-column justify-content-center w-full">
    <div *ngFor="let claim of claims" class="flex w-full justify-content-center">
        <a (click)="showSidecar($event)" [ngClass]="(sideCarVisible$ | async) ? '' : 'cursor-pointer'">
            <app-claim-card [selected]="claim.id == (selectedClaimId$ | async)" [claim]="claim" [showFullCard]="(sideCarVisible$ | async) ?? false"></app-claim-card>
        </a>
    </div>
</div>

